// GAVION ai follow-up (spec §6 demo): the prospect's website text comes from a fixture (no network): one concrete,
// figure-free detail per lead, for the fake drafter.
const DETAILS = [
  "services résidentiels et commerciaux, avec un formulaire de soumission en ligne",
  "interventions d'urgence sept jours sur sept annoncées en page d'accueil",
  "une galerie de réalisations récentes et une zone de service sur la Rive-Nord",
] as const;

export function demoWebsiteDetail(
  company: { id?: unknown; city?: unknown } | null | undefined,
): string | null {
  if (!company) return null;
  const n = Math.abs(Number(company.id) || 0) % DETAILS.length;
  const city =
    typeof company.city === "string" && company.city.trim()
      ? ` (${company.city.trim()})`
      : "";
  return `${DETAILS[n]}${city}`;
}
